import Vue from "vue";
import purchaseOrdersTransformer from "@/transformers/purchase/completeOCs";

export default () => {
  return Vue.$http
    .get('purchase/list_orders_simple_actives/')
    .then((response) => {
      const data = purchaseOrdersTransformer.fetchCollection(response.data)
      return data
    })
    .catch((error) => {
      const response = error.response
      if (response && response.status !== 404) {
        throw error
      } 
    })
};


// WEBPACK FOOTER //
// ./src/services/purchase/fetchOcsForFreights.js